import clsx from 'clsx'
import React from 'react'
import './CustomRadio.scss'

type Option = {
    label: string | number
    value: string | number
}

type Props = {
    className?: string
    name?: string
    options: Option[]
    selectedValue?: string | number | null
    onChange: (value: string | number) => void
    onBlur?: () => void
    onFocus?: () => void
    isDisabled?: boolean
    title?: React.ReactNode
    isRequired?: boolean
}

const baseClass = 'CustomRadio'

function CustomRadio({
    className = '',
    name,
    title,
    options = [],
    selectedValue,
    onChange,
    isDisabled,
    onBlur = () => {},
    onFocus = () => {},
}: Props) {
    return (
        <div className={`${baseClass} ${className}`}>
            {title && (
                <div
                    className={clsx(`${baseClass}__title`, {
                        [`${className}__title`]: className,
                        [`${baseClass}__title--disabled`]: isDisabled,
                        [`${className}__title--disabled`]: isDisabled && className,
                    })}
                >
                    {title}
                </div>
            )}
            <div
                className={clsx(`${baseClass}__items`, {
                    [`${className}__items`]: className,
                    [`${baseClass}__items--disabled`]: isDisabled,
                    [`${className}__items--disabled`]: isDisabled && className,
                })}
            >
                {options.map((option) => (
                    <label
                        key={option.value}
                        className={clsx(`${baseClass}__item`, {
                            [`${baseClass}__item--disabled`]: isDisabled,
                            [`${baseClass}__item--selected`]: selectedValue === option.value,
                            [`${className}__item--disabled`]: isDisabled && className,
                            [`${className}__item--selected`]: selectedValue === option.value && className,
                        })}
                    >
                        <input
                            type="radio"
                            name={name}
                            value={option.value}
                            checked={selectedValue === option.value}
                            onChange={() => onChange(option.value)}
                            onBlur={onBlur}
                            onFocus={onFocus}
                            disabled={isDisabled}
                        />
                        <span
                            className={clsx(`${baseClass}__item-circle`, {
                                [`${baseClass}__item-circle--disabled`]: isDisabled,
                                [`${className}__item-circle--disabled`]: isDisabled && className,
                            })}
                        />
                        <span
                            className={clsx(`${baseClass}__item-label`, {
                                [`${baseClass}__item-label--disabled`]: isDisabled,
                                [`${className}__item-label--disabled`]: isDisabled && className,
                            })}
                        >
                            {option.label}
                        </span>
                    </label>
                ))}
            </div>
        </div>
    )
}

export default CustomRadio
